import { render, staticRenderFns } from "./PartLoaderBig.vue?vue&type=template&id=09fc5ff9&scoped=true&"
import script from "./PartLoaderBig.vue?vue&type=script&lang=js&"
export * from "./PartLoaderBig.vue?vue&type=script&lang=js&"
import style0 from "./PartLoaderBig.vue?vue&type=style&index=0&id=09fc5ff9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fc5ff9",
  null
  
)

export default component.exports